import { render, staticRenderFns } from "./AncientIndividualSampleDetail.vue?vue&type=template&id=bd87f974&scoped=true"
import script from "./AncientIndividualSampleDetail.vue?vue&type=script&lang=js"
export * from "./AncientIndividualSampleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd87f974",
  null
  
)

export default component.exports